import useBreadcrumbs from '@admin/hooks/useAdminBreadcrumbs';
import PageBannerCard from '@shared/components/core/card/PageBannerCard';
import PageHeader from '@shared/components/core/headers/PageHeader';
import SpacedLoader from '@shared/components/loading/SpacedLoader';
import OrgBillingRedirectErrorContent from '@shared/components/organization/billing/OrgBillingRedirectErrorContent';
import useCurrentOrgDetailsFetching from '@shared/hooks/useCurrentOrgDetailsFetching';
import { useTranslation } from 'react-i18next';

export default function OrgBillingRedirectErrorPage() {
    const { t } = useTranslation();
    const { items } = useBreadcrumbs();
    const { currentOrg, canViewOrgDetails, isManagedOrg } = useCurrentOrgDetailsFetching();

    if (!currentOrg) {
        return <SpacedLoader />;
    }

    return (
        <>
            <PageHeader title={t('common:billing.title')} items={canViewOrgDetails ? items : []}></PageHeader>
            <PageBannerCard
                title={t('common:license.upgrade.fallback.title')}
                description={
                    isManagedOrg ? t('common:billing.error') : t('common:license.upgrade.fallback.description')
                }
                fullHeight
                icon="money">
                {!isManagedOrg && <OrgBillingRedirectErrorContent />}
            </PageBannerCard>
        </>
    );
}
